<template>
    <div>
        <v-card flat class="rounded-0 ">
            <ValidationObserver ref="obs" v-slot="{ invalid }">
                <v-form name="formEditarFamiliar" @submit.prevent="enviarDatosFamiliar" class="my-8"
                    :disabled="deshabilitar">
                    <v-row>
                        <v-card-text class="font-weight-bold text-body-1 black--text">
                            INFORMACIÓN SOBRE TUS FAMILIARES
                        </v-card-text>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-combobox :items="familiar" v-model="familiarSeleccionado" return-object deletable-chips
                                :item-value="id" chips
                                :item-text="item => `${item.nombres} ${item.apellido} | DNI: ${item.nrodoc}`"
                                label="Seleccioná familiares para editar" @change="capturarFamiliares"></v-combobox>
                        </v-col>
                    </v-row>
                    <div v-if="familiarSeleccionado">
                        <v-row>
                            <v-col cols="12" md="12" class="ma-0 pa-0">
                                <v-card-title class="py-5 px-3 font-weight-bold text-body-1 primary--text">
                                    <v-icon color="primary" class="mr-2">mdi-pencil-outline</v-icon>
                                    EDITAR: {{ familiarSeleccionado.nombres }} {{ familiarSeleccionado.apellido }}
                                </v-card-title>
                            </v-col>
                            <v-col cols="12" md="6">
                                <ValidationProvider rules="required|max:50|alpha_spaces" v-slot="v">
                                    <v-text-field dense v-model="familiarSeleccionado.nombres"
                                        @input="familiarSeleccionado.nombres = familiarSeleccionado.nombres.toUpperCase()"
                                        :error-messages="v.errors[0]" label="Nombres">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6">
                                <ValidationProvider rules="required|max:50|alpha_spaces" v-slot="v">
                                    <v-text-field dense v-model="familiarSeleccionado.apellido"
                                        @input="familiarSeleccionado.apellido = familiarSeleccionado.apellido.toUpperCase()"
                                        :error-messages="v.errors[0]" label="Apellido">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="3">
                                <ValidationProvider rules="required|numeric|minmax:7,8" v-slot="v">
                                    <v-text-field dense v-model="familiarSeleccionado.nrodoc" maxlength="8"
                                        hide-spin-buttons label="Nro. DNI" :error-messages="v.errors[0]">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="3">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-select dense v-model="familiarSeleccionado.sexo" :items="itemSexo" label="Sexo"
                                        item-value="item" item-text="item" :error-messages="v.errors[0]"></v-select>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="3">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-autocomplete dense v-model="familiarSeleccionado.nacionalidad"
                                        @input="selectNacionalidad" return-object :items="nacionalidades"
                                        item-value="id" item-text="desnacionalidad" label="Nacionalidad"
                                        :error-messages="v.errors[0]">
                                    </v-autocomplete>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="3">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-select dense v-model="familiarSeleccionado.tipnacionalidad"
                                        :error-messages="v.errors[0]" @input="selectTipNacionalidad"
                                        :items="tipoNacionalidad" item-value="tna_id" return-object
                                        item-text="tna_destipnac" label="Tipo de nacionalidad">
                                    </v-select>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="3">
                                <ValidationProvider rules="required|max:10" v-slot="v">
                                    <v-text-field v-model="familiarSeleccionado.fecnacim" dense
                                        label="Fecha de nacimiento:" type="date"
                                        :error-messages="v.errors[0]"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-row v-if="isAuthenticated" class="ma-0">
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select dense v-model="familiarSeleccionado.tipfamiliar"
                                            :items="tiposFamiliares" item-value="id" item-text="desfamiliar"
                                            label="Parentesco" :error-messages="v.errors[0]" return-object>
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" :md="(isSingle) ? '8' : '4'">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-autocomplete dense v-model="familiarSeleccionado.estadocivil"
                                            :items="estadoCivil" item-value="id" item-text="desestadocivil"
                                            label="Estado Civil" :error-messages="v.errors[0]">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4" v-if="familiarSeleccionado.estadocivil !== 1">
                                    <ValidationProvider rules="required|max:10" v-slot="v">
                                        <v-text-field v-model="familiarSeleccionado.fecestadocivil" dense
                                            label="Fecha de estado civil:" type="date"
                                            :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-row class="mx-0">
                                    <v-col cols="12" md="12">
                                        <ValidationProvider rules="required" v-slot="v">
                                            <v-checkbox dense v-model="familiarSeleccionado.discapacidad"
                                                :error-messages="v.errors[0]" true-value="S" false-value="N"
                                                @click="changedFamiliar">
                                                <template v-slot:label>
                                                    <div
                                                        :class="(familiarSeleccionado.discapacidad !== 'N') ? `font-weight-medium primary--text` : `black--text font-weight`">
                                                        ¿Tiene discapacidad?.
                                                    </div>
                                                </template>
                                            </v-checkbox>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-row>
                        </v-row>
                        <v-row>
                            <v-card-text class="font-weight-bold text-body-1 black--text ">
                                DOCUMENTACIÓN REQUERIDA:
                            </v-card-text>
                        </v-row>
                        <v-row v-for="(item, index) in familiares" :key="index"
                            class="mb-14 d-flex flex-row align-end justify-start"
                            :class="($vuetify.breakpoint.smAndDown) ? 'justify-center' : 'justify-space-around'">
                            <InputButtonArchivo op="dniFrenteFamiliar" label="DNI FRENTE"
                                @fileSelected="handleFileSelected">
                            </InputButtonArchivo>
                            <InputButtonArchivo op="dniDorsoFamiliar" label="DNI DORSO"
                                @fileSelected="handleFileSelected">
                            </InputButtonArchivo>
                        </v-row>
                    </div>
                    <v-row class="d-flex flex-row my-8">
                        <v-col class="d-flex justify-end">
                            <v-btn v-if="deshabilitar" @click="habilitaEdicion" outlined elevation="0" class="pa-5"
                                color="primary">
                                <v-icon class="mr-2">mdi-refresh</v-icon>
                                modificar datos
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn type="guardarFamiliar" elevation='0' :disabled="invalid || !formValid" class="pa-6"
                                color="primary">
                                <v-icon class="mr-2">mdi-content-save-outline</v-icon>
                                guardar familiar
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="ma-5"></v-row>
                    <v-card-actions class="custom-card-actions-ha d-flex flex-row ">
                        <v-btn elevation='0' @click="volver" class="pa-5" color="primary">
                            <v-icon class="mr-2">mdi-chevron-left</v-icon>
                            atras
                        </v-btn>
                        <v-btn elevation='0' type="enviarDatosFamiliar" class="pa-5" color="primary">
                            <v-icon class="mr-2">mdi-send</v-icon>
                            enviar trámite
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Alertas from '@/components/alerts/Alertas.vue';
import InputButtonDniFrente from '@/components/inputs/InputButtonDniFrente.vue';
import InputButtonDniDorso from '@/components/inputs/InputButtonDniDorso.vue';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import { mapGetters, mapActions } from 'vuex';


export default {
    components:
    {
        ValidationObserver,
        ValidationProvider,
        Alertas,
        InputButtonDniFrente,
        InputButtonDniDorso,
        InputButtonArchivo,
    },
    data() {
        return {
            labelInfo: '',
            labelTipoFamiliar: '',
            deshabilitar: false,

            familiares:
                [
                    {
                        id: '',
                        nroafi: '',
                        nombres: '',
                        apellido: '',
                        sexo: '',
                        fecnacim: '',
                        tipfamiliar: '',
                        tipdoc: '',
                        nrodoc: '',
                        destipfamiliar: '',
                        fecestadocivil: '',
                        estadocivil: '',
                        nacionalidad: '',
                        desnacionalidad: '',
                        tipnacionalidad: '',
                        fecfallecido: '',
                        discapacidad: 'N',
                        accion: '',
                        destipdoc: '',
                    },
                ],
            fallecido: '',
            checkSubsidio: "0",

            indiceFam: '',

            itemTipDni: [
                { id: 1, item: 'DNI' },
            ],
            // item select tipo de dni
            itemSexo: [
                { id: 1, item: 'F' },
                { id: 2, item: 'M' },
                { id: 3, item: 'X' }], // item select sexo

            formValid: false,

            item: null,
            familiarSeleccionado: '',
        }
    },
    created() {
    },
    mounted() {
        /*         if (this.itemSelected) {
                    this.familiares = Object.assign({}, this.itemSelected)
                    this.familiares.nroafi = this.nroafi
                    this.familiares.accion = "M"
                } else {
                    this.familiares.id = ""
                    this.familiares.fecestadocivil = "1900-01-01"
                    this.familiares.fecfallecido = "1900-01-01"
                    this.familiares.accion = "A"
                }
         */
    },
    computed: {
        ...mapGetters('common', ['tipoNacionalidad', 'estadoCivil', 'tiposFamiliares', 'nacionalidades']),
        /*         ...mapGetters('itemEdit', ['itemSelected', 'indiceSelected']), */
        ...mapGetters('auth', ['isAuthenticated', 'nroafi']),
        ...mapGetters('preafiliacion', ['fechaEstadoCivil', 'idEstadoCivil']),
        ...mapGetters(['familiar']),

        ...mapGetters('dataUser', ['dniFrenteFamiliar', 'dniDorsoFamiliar', 'certDiscFamiliar', 'certFamiliar', 'datosPersonales']),


        //agregado el 19-04
        /*         esPareja() {
                    (this.familiares.tipfamiliar == 1) || (this.familiares.tipfamiliar == 2)
                    return ((this.datosPersonales.estadocivil !== 1))
                }, */
        isSingle() {
            return this.familiares.estadocivil == 1
        },
        esHijo() {
            return this.familiares.tipfamiliar == 3
        },
        esDiscapacitado() {
            return ((this.familiares.discapacidad == 'S') && (this.familiares.discapacidad !== 'undefined'))
        },
        necesitaArchivos() {
            return (this.familiares.tipfamiliar < 4) && (this.familiares.tipfamiliar > 0)
        },
        /*         mdCalculado() {
                    if ((!this.esDiscapacitado) && (!this.necesitaArchivos)) return '6'
                    if (((!this.esDiscapacitado) && (this.necesitaArchivos)) || ((this.esDiscapacitado) && (!this.necesitaArchivos))) return '4'
                    else return '3'
                }, */



    },

    methods: {
        ...mapActions('dataUser', ['addFiles', 'deleteFiles', 'guardarDatosFamiliares', 'modificarFamiliar', 'agregarArchFam', 'preparaFormPersonales']),
        ...mapActions('preafiliacion', ['deleteFiles', 'saveDatosConyuge']),
        addFamiliar() {

        },
        editarData() {
            this.overlay = false
            this.familiares.fecnacim = ''
            this.guardarDatosFamiliares({})
            this.$emit('isCorrectForm', { valid: false, index: this.index })
        },

        volver() {
            this.$emit('back')
        },
        completarDni(value) {
            if (value.length < 8) {
                const newValue = value.padStart(8, '0')
                this.nrodoc = newValue
                return this.nrodoc
            }
        },

        //control de inputButtons para habilitar el btn guardar
        handleFileSelected() {
            if ((!this.esDiscapacitado) && (!this.necesitaArchivos))
                ((this.dniDorsoFamiliar.length != 0) && (this.dniFrenteFamiliar.length != 0)) ? this.formValid = true : this.formValid = false
            else if (!this.esDiscapacitado && this.necesitaArchivos)
                ((this.dniDorsoFamiliar.length != 0) && (this.dniFrenteFamiliar.length != 0) && (this.certFamiliar.length != 0)) ? this.formValid = true : this.formValid = false
            else if (this.esDiscapacitado && !this.necesitaArchivos)
                ((this.dniDorsoFamiliar.length != 0) && (this.dniFrenteFamiliar.length != 0) && (this.certDiscFamiliar.length != 0)) ? this.formValid = true : this.formValid = false
            else {
                ((this.dniDorsoFamiliar.length != 0) && (this.dniFrenteFamiliar.length != 0) && (this.certDiscFamiliar.length != 0)) && (this.certFamiliar.length != 0) ? this.formValid = true : this.formValid = false
            }
        },
        capturarFamiliares(item, index) {
            if (item) {
                this.familiares[0].nombres = item.nombres
                this.familiares[0].apellido = item.apellido
                this.familiares[0].nrodoc = item.nrodoc
                this.familiares[0].tipdoc = item.tipdoc
                this.familiares[0].sexo = item.sexo
                this.familiares[0].nacionalidad = item.nacionalidad
                this.familiares[0].tipnacionalidad = item.tipnacionalidad
                this.familiares[0].fecnacim = item.fecnacim
                this.familiares[0].destipfamiliar = item.destipfamiliar
                this.familiares[0].tipfamiliar = item.tipfamiliar
                this.familiares[0].estadocivil = item.estadocivil
                this.familiares[0].fecestadocivil = item.fecestadocivil
                this.familiares[0].nroafi = this.nroafi
                //this.familiares[0].accion = "M"

                /* 
                                        id: '',
                            nroafi: '',
                            nombres: '',
                            apellido: '',
                            sexo: '',
                            fecnacim: '',
                            tipfamiliar: '',
                            tipdoc: '',
                            nrodoc: '',
                            destipfamiliar: '',
                            fecestadocivil: '',
                            estadocivil: '',
                            nacionalidad: '',
                            desnacionalidad: '',
                            tipnacionalidad: '',
                            fecfallecido: '',
                            discapacidad: 'N',
                            accion: '',
                            destipdoc: '',
                */

            }
        },

        formatDate(date) {
            if (!date) return null
            if (date.includes('/')) {
                let [year, month, day] = date.split('/')
                return `${day}-${month}-${year}`
            } else {
                let [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            }
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        changedFamiliar() {
            //borro el certificado de discapacidad
            this.addFiles({ op: 'certDiscFamiliar', file: '' })
            this.handleFileSelected()
        },

        //guardado localmente antes de hacer peticion a API
        guardarFamiliar() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    //this.guardarDatosFamiliares({ familiar: this.familiares, indice: this.indiceSelected })
                    this.deshabilitar = true
                    //vuelve a listado de familiares ()
                    // this.$emit('familiarGuardado')
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });
            //this.actualizarDatos(formData)
        },
        enviarDatosFamiliar() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    console.log('Envia al store')
                    this.preparaFormPersonales()
                    /* 
                    console.log(this.nuevoAfi)
                                        let keys = Object.keys(this.nuevoAfi)
                    let formData = new FormData()
                    for (let i = 0; i < keys.length; i++) {
                        formData.append(keys[i], this.nuevoAfi[keys[i]]);
                    }
                    console.log(formData) 
                    this.$emit('siguiente')
                    console.log('Datos personales guardados.')
                    this.$emit('siguiente')
                    */
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });
        },
        selectedEstadoCivil(value) {
            this.familiares.estadocivil = value.id
            this.familiares.desestadocivil = value.desestadocivil
        },
        selectNacionalidad(value) {

            this.familiares.nacionalidad = value.id
            this.familiares.desnacionalidad = value.desnacionalidad
        },
        habilitaEdicion() {
            //this.guardarDatosPersonales({})
            this.deshabilitar = false
        },
        selectTipNacionalidad(value) {
            this.familiares.tipnacionalidad = value.tna_id
        },
        /*         selectTipDoc(value) {
                    this.familiares.tipdoc = value.id
                    this.familiares.destipdoc = value.item
                }, */
        selectTipFamiliar(value) {
            if (value.id == 1) {
                this.labelInfo = "certificado de matrimonio"
                this.labelTipoFamiliar = "CERT. MATRIMONIO"
            }
            else if (value.id == 2) {
                this.labelInfo = "certificado de convivencia"
                this.labelTipoFamiliar = "CERT. CONVIVENCIA"
            }
            else if (value.id == 3) {
                this.labelInfo = "acta de nacimiento"
                this.labelTipoFamiliar = "ACTA. NACIMIENTO"
            }
            else {
                this.labelInfo = ""
                this.labelTipoFamiliar = ""
            }
            this.familiares.tipfamiliar = value.id
            this.familiares.destipfamiliar = value.desfamiliar
        }

    },
}

</script>

<style>
.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
    /* Espacio suficiente para las acciones */
}

.custom-card-actions-ha {
    position: fixed;
    /* Fijo en la parte inferior */
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    /* Ajusta la altura según sea necesario */
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    /* Asegúrate de que esté por encima del contenido */
}
</style>